






import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})

export default class DropdownControlIcon extends Vue {
    @Prop({default: "0.3"}) opacity: string;

    declare props: typeof DropdownControlIcon.prototype.$props
}

